import React from 'react';
export const SolutionSection = () => {
  return <section className="py-10 md:py-16 px-6 md:px-10 bg-cream" data-id="element-270">
      <div className="max-w-4xl mx-auto" data-id="element-271">
        <h2 className="section-title text-center mb-6" data-id="element-272">Ahora imagina esto…</h2>
        <div className="mb-12 serif-text text-lg" data-id="element-273">
          <p className="mb-6" data-id="element-274">
            Imagínate llegar a fin de mes sin miedo. Imagínate poder respirar
            tranquila. Imagínate saber exactamente a dónde va tu dinero.
            Imagínate darte un gustito sin culpa. Imagínate tener $100–$200
            extra sin trabajar más. Imagínate ver tu vida mejorar poquito a
            poco, de forma real. Imagínate tener paz mental.
          </p>
          <p className="text-xl font-semibold" data-id="element-275">
            Eso es lo que este sistema hace.
          </p>
        </div>
        <div className="bg-navy text-cream p-8 rounded-xl shadow-xl mb-12" data-id="element-276">
          <h3 className="text-2xl md:text-3xl font-bold mb-4 text-gold" data-id="element-277">
            Te presento: ¿DÓNDE SE VA MI DINERO?
          </h3>
          <p className="text-xl mb-6" data-id="element-278">
            El sistema visual, simple y realista para que tu quincena rinda… sin
            dejar de ayudar a tu familia.
          </p>
          <p className="mb-6" data-id="element-279">
            El primer método creado especialmente para mujeres como tú:
          </p>
          <ul className="space-y-2 mb-6" data-id="element-280">
            <li className="flex items-start" data-id="element-281">
              <span className="text-gold font-bold mr-2" data-id="element-282">•</span>
              <span data-id="element-283">
                Mujeres trabajadoras. Mujeres que ayudan a su familia. Mujeres
                que mandan remesas. Mujeres que no gastan en lujos. Mujeres
                fuertes, cansadas de sentirse solas. Mujeres que quieren
                claridad, no complicaciones.
              </span>
            </li>
          </ul>
          <div className="border-t border-gold/30 pt-6 mt-6" data-id="element-284">
            <p className="mb-4" data-id="element-285">
              No es una app difícil. No es un presupuesto estricto. No es un
              curso técnico con palabras raras.
            </p>
            <p className="text-lg font-semibold" data-id="element-286">
              Es un sistema visual, práctico, rápido y hecho para tu vida real.
            </p>
            <p className="text-xl text-gold font-bold mt-4" data-id="element-287">
              10 minutos al mes = 20–40% más rendimiento en tu quincena. Sin
              ganar más. Sin dejar de ayudar. Sin estresarte. Sin culpas.
            </p>
          </div>
        </div>
      </div>
    </section>;
};